import cn from "classnames";

import styles from "./ScheduleToggler.module.css";

export const ScheduleToggler = ({
  title,
  children,
  leftClickHandler,
  rightClickHandler,
  classNames,
}) => {
  return (
    <div className={classNames}>
      <h2>{title}</h2>
      <div
        className={cn(
          styles.scheduleSwither,
          "d-flex",
          "justify-content-between",
          "align-items-center"
        )}
      >
        <i
          className={cn("fa", "fa-caret-left", styles.scheduleSwither__button)}
          onClick={leftClickHandler}
        />

        {children}
        <i
          className={cn("fa", "fa-caret-right", styles.scheduleSwither__button)}
          onClick={rightClickHandler}
        />
      </div>
    </div>
  );
};
